export const PLAN_CATEGORIES = [
  "Mortgage",
  "Protection",
  "Pension",
  "Investment",
  "GI",
  "Lifetime",
  "Long Term Care",
  "Bridging and Commercial",
];

export const PLAN_TYPE_MAPPING_PATH = [
  "Compliance",
  "Plan Type Mapping",
  "Mappings",
];

export const PLAN_TYPE_AUDIT_PATH = [
  "Compliance",
  "Plan Type Mapping",
  "AuditLogs",
];
